<template>
  <el-main v-loading="loading">
    <div class="box">
      <el-calendar v-model="value" class="calendar">
        <template slot="dateCell" slot-scope="{ date, data }">
          <p :class="data.isSelected ? 'is-selected' : ''">
            {{ setTime(data) }}
          </p>
          <el-tooltip
            class="item"
            effect="dark"
            :content="getHolidayName(data)"
            placement="top-start"
          >
            <p class="name">{{ getHolidayName(data) }}</p>
          </el-tooltip>
        </template>
      </el-calendar>
      <div class="list_wrap">
        <el-card shadow="never">
          <span>{{ year }} {{ language("shopInformation.holidayList") }}</span>
        </el-card>
        <div class="table">
          <cc-table
            :loadData="false"
            :dataArr="holiday"
            :config="configTable"
            :params="paramsTable"
            :refeshParams="refeshTable"
            :emptyText="language('shopInformation.emptyText')"
          ></cc-table>
          <!-- :headerButton="headerButtonTable" -->
        </div>
      </div>
    </div>
  </el-main>
</template>
  <script>
export default {
  data() {
    return {
      value: new Date(),
      holiday: [],
      loading: false,
      year: "",
      /**ccAdminBase參數 */
      configTable: {
        api: "admin/merchant/public/holiday/query?pageSize=100",
        showPager: false,
        columns: [
          //   {
          //     minWidth: 100,
          //     type: "input",
          //     lable: "年份",
          //     prop: "year",
          //   },
          {
            minWidth: 150,
            type: "input",
            prop: "holiday",
            lable: this.language("shopInformation.holidayField"),
          },
          {
            type: "input",
            prop: "startDate",
            lable: this.language("shopInformation.startTimeField"),
            minWidth: 190,
          },
          {
            type: "input",
            lable: this.language("shopInformation.endTimeField"),
            minWidth: 190,
            prop: "endDate",
          },
          //   {
          //     minWidth: 150,
          //     type: "input",
          //     lable: "創建時間",
          //     minWidth: 160,
          //     prop: "createTime",
          //   },
          //   {
          //     minWidth: 150,
          //     type: "input",
          //     lable: "更新時間",
          //     minWidth: 160,
          //     prop: "updateTime",
          //   },
        ],
        buttons: [],
      },
      refeshTable: -1,
      paramsTable: {},
    };
  },
  watch: {
    value: {
      handler() {
        let year = new Date(this.value).getFullYear();
        if (year != this.year) {
          this.getData(
            year - 1 + "-12-1 00:00:00",
            year + 1 + "-1-31 23:59:59",
            year
          );
        }
      },
    },
  },
  methods: {
    setTime(data) {
      let day = data.day.split("-")[2];
      if (day < 10) {
        day = day.slice(1);
      }
      return day;
    },

    getHolidayName(data) {
      let name = [];
      for (let i = 0; i < this.holiday.length; i++) {
        let startDate = new Date(
          this.holiday[i].startDate.replace(/\-/g, "/")
        ).getTime();
        let endDate = new Date(
          this.holiday[i].endDate.replace(/\-/g, "/")
        ).getTime();
        let day = new Date(data.day.replace(/\-/g, "/")).getTime();
        if (day >= startDate && day <= endDate) {
          name.push(this.holiday[i].holiday);
        }
      }
      return name.join("、");
    },
    getData(startDate, endDate, year) {
      this.loading = true;
      this.year = year;
      this.ccRequest
        .do(
          "admin/merchant/public/holiday/queryByTimeRange",
          {
            startDateGE: startDate,
            endDateLE: endDate,
            // pageSize: 100,
          },
          "GET"
        )
        .then((res) => {
          this.loading = false;
          this.holiday = res.data;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    this.getData(
      year - 1 + "-12-1 00:00:00",
      year + 1 + "-1-31 23:59:59",
      year
    );
  },
};
</script>
<style scoped>
.name {
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
}
.box {
  display: flex;
}
.calendar {
  width: 50%;
}
.table {
  width: 100%;
}
.list_wrap {
  width: 50%;
}
</style>